module.exports = __webpack_public_path__ + "static/media/Cera-Pro-Medium.f0777d30.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/Cera-Pro-Medium.woff
// module id = 164
// module chunks = 56